import React from "react";
import { getLibelleByIdInIIdLibelle, isNumeric, SecteurActiviteCompteSocieteList} from "../../config/helpers";

interface IProps {
  Item?: string;
}

const HtmlRenderSecteurActiviteCompteSociete: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item && isNumeric(Item) && getLibelleByIdInIIdLibelle(Number(Item),SecteurActiviteCompteSocieteList)}
    </span>
  );
};

export default HtmlRenderSecteurActiviteCompteSociete;
